import { Body, Radio } from '@assembly-js/design-system';
import clsx from 'clsx';
import React from 'react';

import { SellableStudioPlanId } from './studioPlanFeatures';

interface UpgradePlanSelectorCardProps {
  planId: SellableStudioPlanId;
  title: string;
  priceLabel: string;
  selected: boolean;
  onSelect: (planId: SellableStudioPlanId) => void;
  groupName: string;
}

export const UpgradePlanSelectorCard: React.FC<
  UpgradePlanSelectorCardProps
> = ({ planId, title, priceLabel, selected, onSelect, groupName }) => (
  <div
    role="presentation"
    onClick={() => onSelect(planId)}
    className={clsx(
      'box-border flex h-10 cursor-pointer items-center gap-5 rounded border border-solid px-3 py-2 text-dark-black',
      selected
        ? 'border-black-heading bg-gray-100'
        : 'border-divider-card bg-white hover:border-hover-border',
    )}
  >
    <Radio
      name={groupName}
      label={title}
      aria-label={title}
      checked={selected}
      onChange={() => onSelect(planId)}
    />
    <Body
      size="sm"
      tag="span"
      className="ml-auto shrink-0 leading-[21px] text-gray-small"
    >
      {priceLabel}
    </Body>
  </div>
);
